import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Card, CardContent, Container, Grid} from '@material-ui/core';

import queryParams from 'query-string';

import Header from './Header';
import Page from 'components/Page';
import TableScript from './TableScript';
import TablePagination from 'components/TablePagination';
import {makeStyles} from '@material-ui/styles';

import {useSnackbar} from 'notistack';
import scriptService from 'services/script';
import handleHttpError from 'utils/handleHttpError';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
  },
  container: {
    flexGrow: 1
  },
  cardContent: {
    padding: theme.spacing(0)
  }
}));

function ListScript({history, location}) {
  const classes = useStyles();

  const notistack = useSnackbar();

  const params = queryParams.parse(location.search);
  const query = params.q || '';
  const page = params.page ? parseInt(params.page) : 1;

  const [meta, setMeta] = useState({});
  const [scripts, setScripts] = useState([]);

  useEffect(() => {
    let mounted = true;

    function fetch(query, page) {
      if (mounted) {
        fetchList(query, page);
      }
    }

    fetch(query, page);

    return () => {
      mounted = false;
    }

  }, [setMeta, setScripts, query, page]);

  function fetchList(query = '', page = 1) {
    scriptService.fetchList(query, page).then(({data, meta}) => {
      setScripts(data);
      setMeta(meta);
    });
  }

  function handleChangePage(event, nextPage) {
    event.preventDefault();

    const newParams = {...params, page: nextPage};
    const newLocation = {...location, search: queryParams.stringify(newParams)};

    history.push(newLocation);
  }

  function handleDisable(event, {id}) {
    event.preventDefault();

    scriptService.disable(id).then(response => {
      const newScripts = [...scripts].map(feedback => id === feedback.id ? {...feedback, isActive: false} : feedback);

      setScripts(newScripts);

      notistack.enqueueSnackbar(response.data.message, {
        variant: 'success'
      });
    }).catch(error => handleHttpError(error, null, notistack));
  }

  function handleEnable(event, {id}) {
    event.preventDefault();

    scriptService.enable(id).then(response => {
      const newScripts = [...scripts].map(feedback => id === feedback.id ? {
        ...feedback,
        isActive: true
      } : feedback);

      setScripts(newScripts);

      notistack.enqueueSnackbar(response.data.message, {
        variant: 'success'
      });
    }).catch(error => handleHttpError(error, null, notistack));
  }

  return <Page
    className={classes.root}
    title="Skrip"
  >
    <Container maxWidth="lg">
      <Header/>
      <div className={classes.container}>
        <Grid container spacing={3}>
          <Grid item md={12}>
            <Card>
              <CardContent className={classes.cardContent}>
                <TableScript
                  scripts={scripts}
                  meta={meta}
                  onClickDisable={handleDisable}
                  onClickEnable={handleEnable}
                />
                <TablePagination
                  meta={meta}
                  rowsPerPageOptions={[15]}
                  onHandleChangePage={handleChangePage}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </Container>
  </Page>
}

ListScript.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default ListScript;
